<form [formGroup]="mainForm">
    <div class="row">

      <div class="col-lg-12">
        <div class="card card-primary">
          <div class="card-header text-uppercase"> {{title}} </div>
          <div class="card-body">
            <div class="tile">
              
                  <div class="tile-body">
                   

    
                      <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label> Programme of Interest <small class="text-muted">(required)</small> </label>
                              <select formControlName="ProgrammeId" class="form-control">
                                  <option value="">Select Programme</option>
                                  <option *ngFor="let yes of programmes" value="{{yes.ValueId}}">
                                    {{yes.DisplayValue}}
                                  </option>
    
                                </select>
                            </div>
                          </div>
    
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>
                                  Application Type <small class="text-muted">(required)</small>
                              </label>
                              <select formControlName="PostgraduateStudentTypeId" class="form-control">
                                  <option value="">Select application type</option>
                                  <option *ngFor="let yes of postgraduateStudentTypes" value="{{yes.ValueId}}">
                                    {{yes.DisplayValue}}
                                  </option>
    
                                </select>
    
                            </div>
                          </div>
                      </div>
    



                      <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label> Programme Funding <small class="text-muted">(required)</small> </label>
                             
                              <select formControlName="ProgrammeFundingId" class="form-control">
                                  <option value="">Select Programme Funding</option>
                                  <option *ngFor="let yes of fundings" value="{{yes.Name}}">
                                    {{yes.Name}}
                                  </option>
    
                                </select>
                            </div>
                          </div>
    
    
                          <div class="col-md-6">
                           
                          </div>
                        </div>

                        
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label> Reasons For Choosing The Programme <small class="text-muted">(required)</small> </label>
                              <textarea  formControlName="Reason" class="form-control"></textarea>
    
                            </div>
                          </div>
    
    
                          <div class="col-md-6">
                            <div class="form-group">    
                                <label> Research Topic (Compulsory For MPHIL/PhD Candidates ) 
                                  <small class="text-muted">(required)</small> </label>
                                <textarea type="text" formControlName="ProposedResearchTopic"
                                placeholder="Proposed Research Topic (Compulsory)" class="form-control">
                              </textarea>

    
    
                            </div>
                          </div>
                        </div>

                        <hr/>


                      <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
    
                                <p>NB: All applicants must clearly state outline of proposed research. Please provide this infomation on a seperate sheet to
                                    attached to the printed online document. (Maximum word count should be 2000 for Doctorate and 700 for MPhil)</p>
    
                            </div>
                          </div>
    
                          <div class="col-md-6">
                              <p>Two refeeres at least one of whom should be an academic should comment on the suitability of candidate for the programme.</p>
                          </div>
                        </div>
    




                  </div>
            </div>




          </div>


          <div class="form-footer">
            <div class="form-group text-center">
              <button class="btn btn-default waves-effect waves-light m-1" (click)="goToPrevious()"><i
                  class="fa fa-backward"></i> Go Back</button>

              <button class="btn btn-primary waves-effect waves-light m-1" id="next"
              [disabled]="!isValidChoices()"
              (click)="goToNext(mainForm)">Save &amp; Continue</button>
            </div>
          </div>


        </div>
      </div>

    </div>

  </form>
  
  
  
  